const UPDATE_LANGUAGE = 'I18N/UPDATE_LANGUAGE';
const UPDATE_TRANSLATIONS = 'I18N/UPDATE_TRANSLATIONS';

export default {
  UPDATE_LANGUAGE,
  UPDATE_TRANSLATIONS
};
